module.exports = __webpack_public_path__ + "fonts/TikTokDisplayBold.b11a5dcd.otf";